export const  Contants =
{
    OnboardingFilesUrl : process.env.VUE_APP_ONBOARDING_FILES,
    ElasticApiKey : "ejVldmlITUI1bzVVZURBd0J6MHk6VzBZR1owNVhRN1dtdUxUQlNoWUd0QQ=="
}